// app/localization/extensions.js
// Добавление новых ключей к существующим переводам модулей

export default {};